import {EventEmitter, Injectable} from '@angular/core';
import {TaskServiceService} from './task-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BoardGroupModel, BoardTableModel, PermissionsBoardModel, TaskBoardModel} from '../models/tasktable.model';
import {CrmService} from './api/crm.service';

@Injectable({
    providedIn: 'root'
})
export class TaskOptionsService {
    public selectedBoard: TaskBoardModel|null = null;
    public copySelectedBoard: TaskBoardModel = null;
    public groupSelectedBoard: BoardGroupModel;
    public boards: BoardTableModel[] = [];
    public boardsForOptions: BoardTableModel[] = [];
    public boardsGroups: BoardGroupModel[] = [];
    public isLoadingBoards = false;
    public isLoadingBoardOptions = false;

    public emitChangeBoard: EventEmitter<any> = new EventEmitter<any>();

    public boardAlias: string;
    isPermissionsChanged = false;
    description: string;
    protected access: {
        alias: string,
        permissions: any,
    } = {
        alias: '',
        permissions: null
    };

    constructor(
        protected taskService: TaskServiceService,
        protected router: Router,
        protected activeRouter: ActivatedRoute,
        protected crmService: CrmService,
    ) {
    }

    init(): void {
        void this.onLoadBoards();
        const sub = this.activeRouter.queryParams.subscribe(param => {
            if (param.alias) {
                void this.onLoadBoardOptions(param.alias, true);
            }
        });
        sub.unsubscribe();
    }

    async onLoadBoards(reload = false): Promise<void> {
        this.isLoadingBoards = false;
        this.taskService.getAllBoards(reload).then(res => {
            this.boardsGroups = res.groups;
            this.boards = res.boards;
            res.groups.map(x => {
                this.boards = this.boards.concat(x.boards);
            });

            this.boardsForOptions = this.boards.filter(x => x.rights.is_edit_settings);

            this.isLoadingBoards = true;
            if (this.selectedBoard && this.selectedBoard.group_id) {
                this.groupSelectedBoard = this.boardsGroups.filter(x => x.id === this.selectedBoard.group_id)[0];
            }
        });
    }

    async onLoadBoardOptions(alias: string, reload = false): Promise<void> {
        this.isLoadingBoardOptions = false;
        this.boardAlias = alias;
        this.taskService.getBoard(this.boardAlias, reload).then(res => {
            this.onSetBoard(res.board);
        }).catch(() => {
            this.router.navigate(['account', 'tasks', 'all']);
        });
    }

    async onSetBoard(board: TaskBoardModel | BoardTableModel, reload = false): Promise<void> {
        this.taskService.setBoard(board.alias, reload).then((res) => {
            this.selectedBoard = res.board;
            this.description = this.selectedBoard.description;
            if (this.boardsGroups.length) {
                this.groupSelectedBoard = this.boardsGroups.filter(x => x.id === this.selectedBoard.group_id)[0];
            }
            this.copySelectedBoard = structuredClone(res.board);
            this.emitChangeBoard.emit(this.selectedBoard);
            this.isLoadingBoardOptions = true;
            this.router.navigate([], {queryParams: {alias: this.selectedBoard.alias}});
        });
    }

    async getBoardRights(reload = false): Promise<{
        members: PermissionsBoardModel[],
        departments: PermissionsBoardModel[],
        divisions: PermissionsBoardModel[],
        structure: {
            is_editing: boolean,
            right: 'is_read_my_tasks' |
                'is_read_all_tasks' |
                'is_create_new_task' |
                'is_create_new_comment' |
                'is_set_property_val' |
                'is_edit_settings' |
                'is_set_self_in_task' |
                'is_set_other_in_task',
            title: string,
        }[]
    }> {
        return new Promise(resolve => {
            if (reload || !this.access || this.selectedBoard.alias !== this.access.alias) {
                this.crmService.getBoardRights(this.selectedBoard.alias).subscribe(res => {
                    this.access.alias = this.selectedBoard.alias;
                    this.access.permissions = res;
                    resolve(this.access.permissions);
                });
            } else {
                resolve(this.access.permissions);
            }
        });
    }
}
